const cookieConsent = {
    bindHandler() {
        window.addEventListener('consent.onetrust', function (evt) {
            if (!alphatauri.cookie.optanonConsentGiven) {
                window.location.reload();
            }
        }, false);
    }
};

(function () {
    cookieConsent.bindHandler();
})();

export default cookieConsent;